import { ApiGenericResponse } from "./ApiGenericResponse";
import { AxiosResponse } from "axios";

export class ServiceResponseData extends ApiGenericResponse {
  constructor(response: AxiosResponse) {
    super(response);
  }
}
